var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclamationTriangleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75341 12.0241L6.83171 2.79081C7.33828 1.86978 8.66172 1.86978 9.16828 2.79081L14.2466 12.0241C14.7353 12.9127 14.0924 14 13.0783 14H2.9217C1.90756 14 1.26467 12.9127 1.75341 12.0241ZM8.0007 5.66669C8.46094 5.66707 8.83372 6.04048 8.83333 6.50072L8.83166 8.50072C8.83128 8.96095 8.45787 9.33374 7.99763 9.33335C7.53739 9.33297 7.16461 8.95956 7.16499 8.49932L7.16667 6.49932C7.16705 6.03909 7.54046 5.6663 8.0007 5.66669ZM8.83578 11.1703C8.83578 11.6328 8.46269 12.0077 8.00245 12.0077C7.54221 12.0077 7.16912 11.6328 7.16912 11.1703C7.16912 10.7079 7.54221 10.333 8.00245 10.333C8.46269 10.333 8.83578 10.7079 8.83578 11.1703Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationTriangleIcon);
export default __webpack_public_path__ + "static/media/exclamation-triangle-icon.2b97d7f961f21954c556121a0fc6a13f.svg";
export { ForwardRef as ReactComponent };